(() => {
  const closing = new WeakSet();
  let scheduled = false;
  const protectShopping = () => {
    scheduled = false;
    const panel = document.querySelector('.side-panel.active, .mobile-toggle-wrapper[open]');
    const shopping = document.body.hasAttribute('data-aim-join-backup-used') || panel || document.body.classList.contains('template-cart') || document.querySelector('#aim-join-backup[open]');
    document.querySelectorAll('[role="dialog"]:has([data-testid="klaviyo-form-WJCchu"])').forEach(dialog => {
      if (!dialog.getClientRects().length || getComputedStyle(dialog).display === 'none') {
        closing.delete(dialog);
        return;
      }
      if (!shopping || closing.has(dialog)) return;
      const close = dialog.querySelector('.klaviyo-close-form');
      if (!close) return;
      closing.add(dialog);
      close.click();
      if (panel && panel.hasAttribute('tabindex')) panel.focus({ preventScroll: true });
    });
  };
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(protectShopping);
  });
  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'open', 'data-aim-join-backup-used'] });
  protectShopping();
})();


if (!customElements.get('aim-cart-carousel')) {
  customElements.define('aim-cart-carousel', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.setup());
    }
    setup() {
      this.viewport = this.querySelector('.aim-cart-carousel__products');
      this.controls = this.querySelector('.aim-cart-carousel__controls');
      if (!this.viewport || !this.controls) return;
      this.previous = this.controls.querySelector('[data-direction="previous"]');
      this.next = this.controls.querySelector('[data-direction="next"]');
      this.events = new AbortController();
      const signal = this.events.signal;
      this.controls.addEventListener('click', event => {
        const button = event.target.closest('button[data-direction]');
        if (button && !button.disabled) this.move(button.dataset.direction === 'next' ? 1 : -1);
      }, { signal });
      this.viewport.addEventListener('scroll', () => this.update(), { passive: true, signal });
      this.viewport.addEventListener('keydown', event => {
        if (event.target !== this.viewport) return;
        const rtl = getComputedStyle(this.viewport).direction === 'rtl';
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
        }
      }, { signal });
      this.resizeObserver = new ResizeObserver(() => this.update());
      this.resizeObserver.observe(this.viewport);
      this.update();
    }
    move(direction) {
      const card = this.viewport.firstElementChild;
      if (!card) return;
      const style = getComputedStyle(this.viewport);
      const step = card.getBoundingClientRect().width + (parseFloat(style.columnGap) || 0);
      this.viewport.scrollBy({
        left: direction * step * (style.direction === 'rtl' ? -1 : 1),
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
      });
    }
    update() {
      const maximum = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
      const position = Math.abs(this.viewport.scrollLeft);
      this.controls.hidden = maximum < 2;
      this.previous.disabled = position < 2;
      this.next.disabled = maximum - position < 2;
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.events?.abort();
      this.resizeObserver?.disconnect();
    }
  });
}

